import type { Reactive } from 'vue';
import type { DetailPageContext } from '#layers/block-engine/public';
import { reactiveComputed } from '@vueuse/core';
import { blockContextIsDetailPage, useBlockContext } from '#layers/block-engine/public';

export function useDetailPageContext(): Reactive<DetailPageContext & { isDetailPage: boolean }> {
	const { getRootContext } = useBlockContext();

	return reactiveComputed(() => {
		const rootContext = getRootContext();
		return {
			...rootContext as DetailPageContext,
			isDetailPage: blockContextIsDetailPage({ getRootContext }),
		};
	});
}
